var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.0) scale(1.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5664 20.25L18.8398 23.9648L17.7852 22.9102L19.6953 21H12.5V19.5H19.6953L17.7852 17.5898L18.8398 16.5352L22.5664 20.25ZM14.7266 22.5L16.2266 24H0.5V1C0.5 0.447716 0.947715 0 1.5 0H13.1522C13.4174 0 13.6718 0.105357 13.8593 0.292893L19.7071 6.1407C19.8946 6.32824 20 6.58259 20 6.84781V15.0352L18.5 13.5352V7.5H12.5V1.5H2V22.5H14.7266ZM14 6H17.4336L14 2.56641V6Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.2cb02659b44de5f8094ef027929b0e9a.svg";
export { ForwardRef as ReactComponent };